import React from "react";

export default function ComingSoonSection() {
  return (
    <div className="glass-card p-6 md:p-8">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[var(--muted)]">
            Pro (Coming Soon)
          </p>
          <h3 className="mt-2 text-2xl font-display text-[var(--ink)]">
            Adaptive coaching, profiles, and check-ins.
          </h3>
          <p className="mt-2 text-sm text-[var(--muted)]">
            Pro will add ongoing adjustments based on real intake +
            weight trends, plus conversational intake sessions. No
            subscriptions or accounts are needed for the free
            calculator.
          </p>
        </div>
        <div className="rounded-full bg-white/70 px-4 py-2 text-xs uppercase tracking-[0.2em] text-[var(--muted)]">
          Coming Soon
        </div>
      </div>
    </div>
  );
}
